import useLocalStorage from '~/App/utils/hooks/useLocalStorage'

import type { Session } from '../@types'
import { SESSION_LS_KEY } from '../constants'

const useSessionLocalStorage = () => {
  return useLocalStorage<Session>(SESSION_LS_KEY)
}

export default useSessionLocalStorage
